import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'
import { get } from 'lodash'

const enroll = ({
    userId,
    courseId
}) => {
    return axios.post(urlGenerator.userCourseEnrollment(userId, courseId), {}, createRequestConfig()).then(property('data'))
    //  We don't want to return anything if it all goes to plan!
        .then(() => undefined)
        .catch(err => {
            if (get(err, 'response.status') === 403) {
                return 'Experience is currently full'
            } else {
                throw err
            }
        })
}

const drop = ({
    userId,
    courseId
}) => {
    return axios.delete(urlGenerator.userCourseEnrollment(userId, courseId), createRequestConfig())
        .then(property('data'))
        .catch((error) => Promise.reject(get(error, 'response.data')))
}

export default {
    enroll,
    drop,
}